import React, { useState, useEffect } from "react";

interface LocationFilters {
  province?: string;
}

interface Province {
  name: string;
  province: string;
  count: number;
}

interface LocationFilterProps {
  onLocationChange: (filters: LocationFilters) => void;
  selectedProvince?: string;
  provinces?: Province[];
}

const LocationFilter: React.FC<LocationFilterProps> = ({
  onLocationChange,
  selectedProvince,
  provinces = [],
}) => {
  const [selectedProvinceState, setSelectedProvinceState] = useState(
    selectedProvince || ""
  );

  useEffect(() => {
    setSelectedProvinceState(selectedProvince || "");
  }, [selectedProvince]);

  const handleProvinceChange = (province: string) => {
    setSelectedProvinceState(province);

    const filters: LocationFilters = {};
    if (province) {
      filters.province = province;
    }

    onLocationChange(filters);
  };

  const handleReset = () => {
    setSelectedProvinceState("");
    onLocationChange({});
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-neutral-200 p-4">
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-neutral-700">
            Województwo:
          </label>
          <select
            value={selectedProvinceState}
            onChange={(e) => handleProvinceChange(e.target.value)}
            className="border border-neutral-300 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
          >
            <option value="">Wszystkie województwa</option>
            {provinces?.map((province: Province) => (
              <option key={province.province} value={province.province}>
                {province.name.replace(/^Województwo\s+/i, "")} (
                {province.count})
              </option>
            ))}
          </select>
        </div>

        {selectedProvinceState && (
          <button
            onClick={handleReset}
            className="text-sm text-primary-600 hover:text-primary-700 font-medium"
          >
            Wyczyść filtry
          </button>
        )}
      </div>

      {selectedProvinceState && (
        <div className="mt-2 text-xs text-neutral-500">
          Wybrane województwo:{" "}
          {
            provinces?.find(
              (province: Province) =>
                province.province === selectedProvinceState
            )?.name
          }
        </div>
      )}
    </div>
  );
};

export default LocationFilter;
